module.exports = __webpack_public_path__ + "img/logo-bkg.89c8ee4b.svg";